module.exports = __webpack_public_path__ + "img/retail02.361c32f7.png";